const NICheck = (collection: any, delivery: any) =>
  (collection.country === 'GB' && delivery.country === 'GB') &&
  ((collection?.postcode || collection.zip).toUpperCase().startsWith('BT')
    && !(delivery?.postcode || delivery.zip).toUpperCase().startsWith('BT')) ||
  (!(collection?.postcode || collection.zip).toUpperCase().startsWith('BT') &&
    (delivery?.postcode || delivery.zip).toUpperCase().startsWith('BT'));

export default NICheck;